import React from "react";
const RemoveFavourite = (props)=>{
    return (
        <>
        <span className='mr-2'>Remove from Favourites ❌</span>

        </>
    );
}
export default RemoveFavourite;